import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../visa';
import { SessionSelectors } from '../session/session-controller/selectors';
import { SessionStates } from '../session/session-controller/states';
// import { PersonalizationActions } from '../../state-controllers/application-controller/store/actions';
// import { PersonalizationSelectors } from '../../state-controllers/application-controller/store/selectors';
// import { SessionActions } from '../../state-controllers/session-controller/store/actions';
// import { SessionSelectors } from '../../state-controllers/session-controller/store/selectors';
// import { SessionStates } from '../../state-controllers/session-controller/store/states';

@Component({
  selector: 'app-personalization',
  templateUrl: './personalization.component.html',
  styleUrls: ['./personalization.component.scss']
})
export class PersonalizationComponent implements OnInit, OnDestroy {

  @Input() routes
  @Input() personalizationLabel: string;

  private subs = new SubSink();

  src$ = this.store.select(SessionSelectors.selectAvatar).pipe(
    map(a => {

      return !a.includes('undefined') ?
        `${a}?tenantCode=${this.apiVisa.tenantCode}&jwtToken=${this.apiVisa.jwt_secret}` :
        'https://media.istockphoto.com/vectors/profile-placeholder-image-gray-silhouette-no-photo-vector-id1016744034?b=1&k=6&m=1016744034&s=612x612&w=0&h=dbicqM9p31ex5Lm-FpsdOjHkPZM_6Lmkb02qJO9SY5E='
    }),
  );
  readonly apiVisa = AppConfig.apiVisa; profile$ = this.store.select(SessionSelectors.selectUserProfile).pipe(
    map((a: any) => ({
      name: a?.appLoginSubject.name ? a?.appLoginSubject.name : '<blank>',
      email: a?.appLoginPrincipalList.find(p => p.principal_type === 'EMAIL_USERNAME')?.principal_id
    }))
  );

  // readonly appletSettings$ = this.store.select(SessionSelectors.selectAppletSettings);
  // readonly logoBgColor$ = this.appStore.select(PersonalizationSelectors.selectLogoBgColor);
  // readonly sidebarBgColor$ = this.appStore.select(PersonalizationSelectors.selectSidebarBgColor);
  // readonly errorLog$ = this.viewColFacade.collectErrorLog();

  constructor(
    private snack: MatSnackBar,
    private readonly store: Store<SessionStates>
  ) { }

  ngOnInit() { }

  onSidebarBgChange(color: string) {
    // this.appStore.dispatch(PersonalizationActions.changeSidebarBgColor({color}));
  }

  onReport() {
    this.snack.open('Squashed a Bug!', 'Close');
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}


